/***
 *
 *   TICKET STATS STYLES
 *   A single segmented band rather than a row of separate cards.
 *
 *   Two things drive this. "No padding between them": the gap is gone and the
 *   cells are separated by hairlines instead. Each cell draws only its leading
 *   edges (`border-l border-t`) and is pulled back over its neighbour by a
 *   matching `-ml-px -mt-px`, so touching edges collapse into one rule and the
 *   grid's outer left/top borders fall outside the `overflow-hidden` container.
 *
 *   The two techniques this is NOT: `divide-x` puts a spurious rule on whichever
 *   tile starts a wrapped row, and `gap-px` over a `bg-border` container leaves
 *   the empty trailing track of a 5-into-3 grid painted solid border colour.
 *
 *   "Glued to the header": the band escapes ContentContainer's `px-4/6/8` and
 *   `py-6` with matching negative margins, so its top edge meets the header's
 *   bottom border with no seam and its own `border-b` becomes the rule beneath
 *   it. If the tickets page ever opts out of that container's padding itself,
 *   these escapes come out with it.
 *
 **********/

// px-4 md:px-6 lg:px-8 + py-6 — see components/layout/app/app.tailwind.js
const BLEED = '-mx-4 -mt-6 md:-mx-6 lg:-mx-8';

const GRID = `${BLEED} grid shrink-0 grid-cols-2 overflow-hidden border-b bg-surface
    md:grid-cols-3 lg:grid-cols-5`;

// `border-0` zeroes StatCard's own bare `border`; `border-l`/`border-t` are a
// different conflict group, so they survive it and set just those two edges.
const CELL = '-ml-px -mt-px border-0 border-l border-t';

const Style = {
    container: GRID,
    skeletonGrid: GRID,

    // Overrides StatCard's own card chrome: inside a band, the rounding and
    // shadow that make a standalone tile read as a card only add noise.
    card: `w-full rounded-none shadow-none ${CELL}`,

    // Matches a loaded cell's box (h-10 icon well + p-4) so the band does not
    // resize when the query lands.
    skeletonCell: `flex h-[72px] items-center bg-surface p-4 ${CELL}`,
    skeletonBar: 'h-10 w-full',
};

export default Style;
